import type { FC, ReactNode } from "react";

import { isEmptyHtml } from "@ui/utils/isEmptyHtml";
import classNames from "classnames";
import dompurify from "isomorphic-dompurify";

import { Typography } from "../Typography";

import styles from "./CardGeneric.module.scss";

export type CardGenericHeaderSectionProps = {
  icon?: ReactNode;
  title?: string;
  secondaryTitle?: string;
  description?: string;
  reverseOrder?: boolean;
};

const { sanitize } = dompurify;

export const CardGenericHeaderSection: FC<CardGenericHeaderSectionProps> = ({
  icon,
  title,
  secondaryTitle,
  description,
  reverseOrder = false,
}) => {
  return (
    <div data-testid="card-generic-header-section" className={styles.headerSection}>
      {icon && <>{icon}</>}
      <div className={styles.titleContainer}>
        {title && (
          <Typography
            variant="h2"
            className={classNames(styles.textColor, {
              [styles.titleReverse]: reverseOrder,
            })}
          >
            {title}
          </Typography>
        )}
        {secondaryTitle && (
          <span
            className={classNames(styles.secondaryTitle, {
              [styles.secondaryTitleReverse]: reverseOrder,
            })}
          >
            {secondaryTitle}
          </span>
        )}
      </div>
      {!isEmptyHtml(description) && (
        <div
          className={classNames(styles.textColor, styles.description)}
          dangerouslySetInnerHTML={{
            __html: sanitize(description ?? ""),
          }}
        />
      )}
    </div>
  );
};
